import React, {useContext, useEffect, useState, useCallback} from 'react';
import PdfReader from 'components/pdfReader/pdfReader';
import { QRCodeSVG } from 'qrcode.react';
import ClosePopupBtn from 'components/buttons/closePopupBtn';
import HTMLReactParser from 'html-react-parser';
export default function PdfFormation(props) {
    const {file, close, setCounter, counterDefault} = props
    const [lien, setLien] = useState("nope")
    useEffect(() => {
        // let description = file.description
        // let filtre1 = description.replace("<html-blob>", '')
        // let filtre2 = filtre1.replace("</html-blob>", '')
        // console.log(HTMLReactParser(filtre2).props.children.props.children)
        // setLien(HTMLReactParser(filtre2).props.children.props.children)
        console.log(file.description)
        setCounter(counterDefault)
      }, [])
    return (
        <div className='flex column center' id="pdfFormation">
            <PdfReader file={file.description} close={close} setCounter={setCounter} counterDefault={counterDefault} drive={true}/>
            {/* <iframe src={lien} frameborder="0"></iframe> */}
           
            <div className='w100 flex center' style={{marginTop : "50px"}}>
                <div className='cadre cadreBlanc' style={{color : "white"}}>
                    Télécharger la fiche de formation 
                </div>
                <QRCodeSVG value={`https://chu-rouen-drhf.spin-io.fr/pdf/${file.description}.pdf`} fgColor='white' bgColor='none' className='qrcode' size={150} />
            </div>
            <ClosePopupBtn close={close}/>
        </div>

    );
   
}